import { Box, Button, Checkbox, Stack, Typography } from '@mui/material';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../store/actions/GlobalActions';
import { DocumentDialog } from './DocumentDialog';
import { selectCountry, selectRegistrationRequest } from '../../store/selectors/GlobalSelector';
import axios from '../../util/Axios';
import { useTranslation } from 'react-i18next';
import { ThermsAndConditionsUs } from './04-ThermsAndConditionsUs';

export function ThermsAndConditions() {
  const { t } = useTranslation();
  const registrationRequest = useSelector(selectRegistrationRequest);
  const country = useSelector(selectCountry);
  const [generelThermsAccepted, setGeneralConditions] = useState(false);
  const [openGeneral, setOpenGeneral] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicy] = useState(false);
  const [openPrivacy, setOpenPrivacy] = useState(false);

  const [dataProcessingAggreementAccepted, setDataProcessing] = useState(false);
  const [openDataProcessing, setOpenDataProcessing] = useState(false);

  const dispatch = useDispatch();
  const handleBack = () => {
    dispatch({ type: actions.PREVIOUS_REGISTRATION_STEP });
  };

  const handleRegister = () => {
    dispatch({ type: actions.ACCEPT_LEGAL_TERMS, payload: { generelThermsAccepted, privacyPolicyAccepted, dataProcessingAggreementAccepted } });
    registerDoctor();
  };

  const registerDoctor = () => {
    const request = { ...registrationRequest, legalAggreements: { generelThermsAccepted, privacyPolicyAccepted, dataProcessingAggreementAccepted } };

    axios.post(`users/doctors`, request).then((resp) => {
      dispatch({ type: actions.FINISH_REGISTRATION });
    });
  };

  return (
    <>
      {country === 'BG' ? (
        <Stack direction="column" spacing={1}>
          <Stack direction="row" spacing={1}>
            <Checkbox checked={generelThermsAccepted} onChange={(e) => setGeneralConditions(e.target.checked)} />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>Запознах се с </Typography>
              <a href="https://api.fastai.tech/agreements/general_terms_2023-11-01.pdf" target="_blank" rel="noreferrer">
                <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>общите условия</Typography>
              </a>
              <Typography>и ги приемам.</Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Checkbox checked={privacyPolicyAccepted} onChange={(e) => setPrivacyPolicy(e.target.checked)} />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>Запознах се с </Typography>
              <a href="https://api.fastai.tech/agreements/privacy_2023-11-01.pdf" target="_blank" rel="noreferrer">
                <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>политиката за поверителност</Typography>
              </a>
              <Typography>и я приемам.</Typography>
            </Box>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Checkbox checked={dataProcessingAggreementAccepted} onChange={(e) => setDataProcessing(e.target.checked)} />
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Typography>Запознах се със </Typography>
              <a href="https://api.fastai.tech/agreements/data_processing_aggreement_latest.pdf" target="_blank" rel="noreferrer">
                <Typography sx={{ paddingLeft: '5px', paddingRight: '5px' }}>споразумение за обработка на данни</Typography>
              </a>
              <Typography>и го приемам.</Typography>
            </Box>
          </Stack>
        </Stack>
      ) : (
        <ThermsAndConditionsUs
          generelThermsAccepted={generelThermsAccepted}
          setGeneralConditions={setGeneralConditions}
          privacyPolicyAccepted={privacyPolicyAccepted}
          setPrivacyPolicy={setPrivacyPolicy}
          dataProcessingAggreementAccepted={dataProcessingAggreementAccepted}
          setDataProcessing={setDataProcessing}
        />
      )}
      <Stack direction="row" sx={{ marginTop: 5 }}>
        <Button sx={{ width: '50%' }} onClick={handleBack}>
          {t('back')}
        </Button>
        <Button onClick={handleRegister} disabled={!(generelThermsAccepted && privacyPolicyAccepted && dataProcessingAggreementAccepted)} sx={{ width: '50%' }} variant="contained" color="primary">
          {t('register')}
        </Button>
      </Stack>

      <DocumentDialog open={openGeneral} handleClose={() => setOpenGeneral(false)} documentUrl="https://api.fastai.tech/agreements/general_terms_2023-11-01.pdf" />
      <DocumentDialog open={openPrivacy} handleClose={() => setOpenPrivacy(false)} documentUrl="https://api.fastai.tech/agreements/privacy_2023-11-01.pdf" />
      <DocumentDialog open={openDataProcessing} handleClose={() => setOpenDataProcessing(false)} documentUrl="https://api.fastai.tech/agreements/data_processing_aggreement_latest.pdf" />
    </>
  );
}
